const { getElement, getElements, debounce } = window.BAO.Utils
class BackInStock extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    if (this.els?.submit?.exists) {
      this.listeners.add(
        this.els.submit.element,
        'click',
        this.handleClick.bind(this),
      )
    }

    this.setupTriggerListeners = this.setupTriggerListeners.bind(this)

    window.addEventListener(`AFTER_QUICKBUY_RENDER`, this.setupTriggerListeners)
    window.addEventListener(
      `AFTER_PRODUCT_CARD_RENDER`,
      debounce(this.setupTriggerListeners, 250),
    )

    this.setupTriggerListeners()
  }

  setupTriggerListeners () {
    const externalTriggerEls = getElements(this.externalEls?.trigger?.selector)
    if (externalTriggerEls?.length) {
      this.handleExternalTriggerClick = this.handleExternalTriggerClick.bind(
        this,
      )
      externalTriggerEls.forEach(externalTriggerEl => {
        this.listeners.remove(
          externalTriggerEl,
          'click',
          this.handleExternalTriggerClick,
        )
        this.listeners.add(
          externalTriggerEl,
          'click',
          this.handleExternalTriggerClick,
        )
      })
    }
  }

  handleExternalTriggerClick (event) {
    const externalTriggerEl = event.target.closest(
      this.externalEls.trigger.selector,
    )
    if (!externalTriggerEl) return

    this.productId = externalTriggerEl?.dataset?.productId
    this.variantId = externalTriggerEl?.dataset?.variantId

    this.setProductTitle(externalTriggerEl)
  }

  setProductTitle (externalTriggerEl) {
    if (
      !this.els?.productTitle?.exists ||
      !externalTriggerEl?.dataset?.variantTitle ||
      !externalTriggerEl?.dataset?.productTitle
    ) {
      return
    }
    this.els.productTitle.element.setAttribute(`aria-hidden`, true)
    if (
      !externalTriggerEl.dataset.variantTitle.toLowerCase()?.includes('default')
    ) {
      this.els.productTitle.element.textContent =
        externalTriggerEl.dataset.variantTitle
    } else {
      this.els.productTitle.element.textContent =
        externalTriggerEl.dataset.productTitle
    }
    this.els.productTitle.element.setAttribute(`aria-hidden`, false)
  }

  async handleClick (event) {
    const submitEl = event.target.closest(this.els?.submit?.selector)
    if (!submitEl) return
    event.preventDefault()
    event.stopPropagation()

    if (this.email.length < 1) return
    const BISResponse = await this.sendBIS()
    this.handleResponse(BISResponse)
    return false
  }

  async sendBIS () {
    // eslint-disable-next-line no-undef
    return BIS.create(this.email, this.variantId, this.productId, {
      accepts_marketing: !!this.els?.newsletterCheckbox?.element?.checked,
    })
  }

  handleClose () {
    const close = getElement('.bis-BackInStock_Close', { context: this })
    const successModal = getElement('.mod-Modal-BackInStockSuccess')

    if (!close || !successModal) return

    close?.click()

    successModal.ariaHidden = false

    setTimeout(() => {
      successModal.ariaHidden = true
    }, 3000)
  }

  handleResponse (response) {
    if (!this.els.response.exists) return
    const responseEl = this.els.response.element
    const { errors = null, message = null } = response
    const errorArray = errors ? Object.keys(errors).map(key => errors[key]) : []

    this.toggleResponse(false)

    responseEl.innerHTML = ''
    responseEl.dataset.status = response.status.toLowerCase()
    responseEl.innerHTML = message ? `<p>${message}</p>` : responseEl.innerHTML

    errorArray.forEach(error => {
      responseEl.innerHTML += `<p>${error}</p>`
    })

    this.toggleResponse(true)

    if (response.status === 'OK') {
      this.handleClose()
    }
  }

  toggleResponse (isVisible) {
    if (!this.els?.response?.exists) return
    this.els.response.element.setAttribute(`aria-hidden`, !isVisible)
  }

  get email () {
    if (!this.els?.email?.exists) return ``
    return this.els.email.element.value
  }

  get productId () {
    return this._productId
  }

  set productId (productId) {
    this._productId = productId
    if (!this.els?.submit?.exists) return
    this.els.submit.element.setAttribute(`data-product-id`, productId)
  }

  get variantId () {
    return this._variantId
  }

  set variantId (variantId) {
    this._variantId = variantId
    if (!this.els?.submit?.exists) return
    this.els.submit.element.setAttribute(`data-variant-id`, variantId)
  }

  get externalTriggerSelector () {
    return `[data-back-in-stock-external-el="trigger"]`
  }
}

if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', BackInStock)
}
